// @ts-nocheck
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import { ResourcePlanningService } from './resourcePlanningService';
import { DASHBOARD_QUERY_KEYS } from '../../api/dashboardQueries';

const RESOURCE_PLANNING = 'resourcePlanning';

export const RESOURCE_PLANNING_QUERY_KEYS = {
  ALL: [RESOURCE_PLANNING],

  teamMembersWithEffort: {
    ROOT: [RESOURCE_PLANNING, 'teamMembersWithEffort'],
    key: (params = {}) => [RESOURCE_PLANNING, 'teamMembersWithEffort', params],
  },

  userTaskDetails: {
    ROOT: [RESOURCE_PLANNING, 'userTaskDetails'],
    key: (params = {}) => [RESOURCE_PLANNING, 'userTaskDetails', params],
  },

  openTaskCount: {
    ROOT: [RESOURCE_PLANNING, 'openTaskCount'],
    key: (params = {}) => [RESOURCE_PLANNING, 'openTaskCount', params],
  },

  templateTaskList: {
    ROOT: [RESOURCE_PLANNING, 'templateTaskList'],
    key: (params = {}) => [RESOURCE_PLANNING, 'templateTaskList', params],
  },

  taskList: {
    ROOT: [RESOURCE_PLANNING, 'taskList'],
    key: (params = {}) => [RESOURCE_PLANNING, 'taskList', params],
  },

  eventsCount: {
    ROOT: [RESOURCE_PLANNING, 'eventsCount'],
    key: (body = {}) => [RESOURCE_PLANNING, 'eventsCount', body],
  },

  actionEvents: {
    ROOT: [RESOURCE_PLANNING, 'actionEvents'],
    key: (params = {}) => [RESOURCE_PLANNING, 'actionEvents', params],
  },
};

export const useTeamMembersWithEffortQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.teamMembersWithEffort.key,
    ResourcePlanningService.getTeamMembersWithEffort,
    params,
    options
  );

export const useUserTaskDetailsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.userTaskDetails.key,
    ResourcePlanningService.getUserTaskDetails,
    params,
    options
  );

export const useOpenTaskCountQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.openTaskCount.key,
    ResourcePlanningService.getOpenTaskCount,
    params,
    options
  );

export const useTemplateTaskListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.templateTaskList.key,
    ResourcePlanningService.getTemplateTaskList,
    params,
    options
  );

export const useTaskListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.taskList.key,
    ResourcePlanningService.getTaskList,
    params,
    options
  );

export const useEventsCountQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.eventsCount.key,
    ResourcePlanningService.getEventsCount,
    params,
    options
  );

export const useActionEventsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    RESOURCE_PLANNING_QUERY_KEYS.actionEvents.key,
    ResourcePlanningService.getAllActionEvents,
    params,
    options
  );

export const useUpdateActionEventMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ResourcePlanningService.updateActionEvent, {
    ...options,
    invalidateQueries: [
      RESOURCE_PLANNING_QUERY_KEYS.actionEvents.ROOT,
      RESOURCE_PLANNING_QUERY_KEYS.eventsCount.ROOT,
    ],
  });
};

export const useDeleteActionEventMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ResourcePlanningService.deleteActionEvent, {
    ...options,
    invalidateQueries: [
      RESOURCE_PLANNING_QUERY_KEYS.actionEvents.ROOT,
      RESOURCE_PLANNING_QUERY_KEYS.eventsCount.ROOT,
      DASHBOARD_QUERY_KEYS.alertData.ROOT,
      DASHBOARD_QUERY_KEYS.pipelineData.ROOT,
    ],
  });
};
